import React from "react";
import { BrowserRouter as Test, Route, Switch } from "react-router-dom";
import { resolveURL, BASE_URL } from '../core/URLResolver';
import Page from '../core/screens/Page';
import {History, HistoryEvent} from './History';
import Pages from '../Pages';
import MetaController from './MetaController';
import BrowserRouter from "./BrowserRouter";

interface props
{
	content:object,
	location?:any,
	onChange?
}

export default class RouteBuilder extends React.Component<props>
{

	main = React.createRef<HTMLElement>();
	routeScrollable = {};
	history = new History();
	metaController:MetaController;
	prevLocation = null;
	currentLocation = null;
	constructor(props)
	{
		super(props);
		resolveURL('');
		this.history.on(HistoryEvent.CHANGE, this._routeChange);
	}
	private _routeChange = () => {
		if(this.metaController)
		{
			this.metaController.updateMeta(this.history.path);
		}
	}

	private _buildRoutes()
	{
		return this._buildRouteRecursive(this.props.content);
	}

	private _buildRouteRecursive(routeData:Object, parentPath = '')
	{
		if(!routeData['routes']) return;

		let pages = [];
		let reverse = true;

		for (let [path, data] of Object.entries(routeData['routes']))
		{
			path = '/' + parentPath + '/' + path + '/';
			path = path.replace(/\/+/g, '/');
			let children, content;
			if(data['routes'])
			{
				children = this._buildRouteRecursive(data, path);
			}

			let Comp: typeof Page;
			Comp = Pages[data['name']] || Pages['__default__'];

			if (this.props.content['pages'] && this.props.content['pages'][data['id']]) {
				content = this.props.content['pages'][data['id']];
			}
			let child = (<Comp key={path} path={path} data={data} content={content}>{children}</Comp>);
			if(data['wrapRouter'] === false)
			{
				this.routeScrollable[path] = true;
				reverse = false;
			}
			pages.push(child);
		}
		if(reverse)
		{
			pages = pages.reverse();
		}

		return pages;
	}

	private _buildChildren(children, useRoute:boolean = true)
	{

	}

	componentDidMount()
	{
		this.metaController = new MetaController(this.props.content);
		this._routeChange();
	}

	render()
	{
		if(!this.prevLocation)
		{
			this.prevLocation = window.location;
		}
		if(!this.currentLocation)
		{
			this.currentLocation = window.location;
		}
		return (
			<React.Fragment>
			<main ref={this.main}>
				<BrowserRouter onChange={this.props.onChange}>
					{this._buildRoutes()}
				</BrowserRouter>
			</main>
			{this.props.children}
			</React.Fragment>
		)
	}
}
